const NorthCarolinaUsage = ([jan, feb, mar, apr, ma, jun, jul, aug, sep, oct, nov, dec], usageAnnual) => {

  // const average = (arr) => arr.reduce((a, b) => a + b) / arr.length
  const total = (arr) => arr.reduce((a, b) => a + b)

  let janBase = 963
  let febBase = 913
  let marBase = 796
  let aprBase = 785
  let mayBase = 822
  let junBase = 1166
  let julBase = 1379
  let augBase = 1426
  let septBase = 1280
  let octBase = 863
  let novBase = 745
  let decBase = 865

  let base = [janBase, febBase, marBase, aprBase, mayBase, junBase, julBase, augBase, septBase, octBase, novBase, decBase]

  let baseTotal = total(base)

  const calc = (num1, num2) => {
    if (num1) {
      return num2
    } return 0
  }

  let january = calc(jan, janBase)
  let february = calc(feb, febBase)
  let march = calc(mar, marBase)
  let april = calc(apr, aprBase)
  let may = calc(ma, mayBase)
  let june = calc(jun, junBase)
  let july = calc(jul, julBase)
  let august = calc(aug, augBase)
  let september = calc(sep, septBase)
  let october = calc(oct, octBase)
  let november = calc(nov, novBase)
  let december = calc(dec, decBase)

  const baseArray = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
  const usage = [+jan, +feb, +mar, +apr, +ma, +jun, +jul, +aug, +sep, +oct, +nov, +dec]

  let totalUsage = total(usage)
  let totalBase = total(baseArray)

  let ratio = totalBase / totalUsage

  const calc2 = (num1, num2) => {
    if (num1) {
      return num1
    } return Math.round(1 / ratio * num2)
  }

  let januaryTotal = calc2(jan, janBase)
  let februaryTotal = calc2(feb, febBase)
  let marchTotal = calc2(mar, marBase)
  let aprilTotal = calc2(apr, aprBase)
  let mayTotal = calc2(ma, mayBase)
  let juneTotal = calc2(jun, junBase)
  let julyTotal = calc2(jul, julBase)
  let augustTotal = calc2(aug, augBase)
  let septemberTotal = calc2(sep, septBase)
  let octoberTotal = calc2(oct, octBase)
  let novemberTotal = calc2(nov, novBase)
  let decemberTotal = calc2(dec, decBase)

  let totalArray = [+januaryTotal, +februaryTotal, +marchTotal, +aprilTotal, +mayTotal, +juneTotal, +julyTotal, +augustTotal, +septemberTotal, +octoberTotal, +novemberTotal, +decemberTotal]

  //TO FIND THE MONTHLY USAGE IF ONLY GIVEN ANNUAL USAGE FROM SALES REP
  const calc3 = (num1, num2) => {
    return Math.round((num1 / baseTotal) * num2)
  }

  let janAnn = calc3(janBase, usageAnnual)
  let febAnn = calc3(febBase, usageAnnual)
  let marAnn = calc3(marBase, usageAnnual)
  let aprAnn = calc3(aprBase, usageAnnual)
  let mayAnn = calc3(mayBase, usageAnnual)
  let junAnn = calc3(junBase, usageAnnual)
  let julAnn = calc3(julBase, usageAnnual)
  let augAnn = calc3(augBase, usageAnnual)
  let septAnn = calc3(septBase, usageAnnual)
  let octAnn = calc3(octBase, usageAnnual)
  let novAnn = calc3(novBase, usageAnnual)
  let decAnn = calc3(decBase, usageAnnual)

  let annualArray = [janAnn, febAnn, marAnn, aprAnn, mayAnn, junAnn, julAnn, augAnn, septAnn, octAnn, novAnn, decAnn]

  let annualUsage = total(annualArray)


  // let janProd = Math.round(annualProduction * .048627710)
  // let febProd = Math.round(annualProduction * .059095030)
  // let marProd = Math.round(annualProduction * .085222121)
  // let aprProd = Math.round(annualProduction * .105291354)
  // let mayProd = Math.round(annualProduction * .110978324)
  // let juneProd = Math.round(annualProduction * .118766999)
  // let julyProd = Math.round(annualProduction * .116459243)
  // let augProd = Math.round(annualProduction * .107805159)
  // let sepProd = Math.round(annualProduction * .084233083)
  // let octProd = Math.round(annualProduction * .072158576)
  // let novProd = Math.round(annualProduction * .046567213)
  // let decProd = Math.round(annualProduction * .044795187)

  // let prodArray = [janProd, febProd, marProd, aprProd, mayProd, juneProd, julyProd, augProd, sepProd, octProd, novProd, decProd]

  // // let annualUsage = total(annualArray)

  // console.log(prodArray, total(prodArray))

  // let sum = baseArray.map(function(num, i){
  //   return num + totalArray[i]
  // })

  // console.log(totalArray, sum)



  if (usageAnnual) {
    return annualArray
  }
  return totalArray
  
}

export default NorthCarolinaUsage